<header>

  <div id="menu">

    <div class="menuToggle">
      <input type="checkbox" />
      <span></span>
      <span></span>
      <span></span>
      <ul class="menuCel">
        <li> <a href=# routerLink="/">Home</a></li>
        <li> <a href=# routerLink="/about">About</a></li>
        <li> <a href=# routerLink="/list">Movies</a></li>
      </ul>
    </div>

    <div class="menuWeb">
      <ul>
        <li> <a href=# routerLink="/">Home</a></li>
        <li> <a href=# routerLink="/about">About</a></li>
        <li> <a href=# routerLink="/list">Movies</a></li>
      </ul>
    </div>

  </div>

</header>

<div class="wrap">
  <router-outlet></router-outlet>
</div>